import { render, staticRenderFns } from "./project-new.vue?vue&type=template&id=21c92469&scoped=true"
import script from "./project-new.vue?vue&type=script&lang=js"
export * from "./project-new.vue?vue&type=script&lang=js"
import style0 from "./project-new.vue?vue&type=style&index=0&id=21c92469&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c92469",
  null
  
)

export default component.exports